import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../../auth/services/auth.service';
import { LanguageService, AlertsService } from 'itcores-fw';
/**
 * Adds a default error handler to all requests.
 */
@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private alertService: AlertsService,
    private language: LanguageService,
    private authService: AuthService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(request)
      .pipe(catchError(error => this.errorHandler(error)));
  }


  // Customize the default error handler here if needed
  private errorHandler(error: HttpErrorResponse): Observable<HttpEvent<any>> {
    this.alertService.hideLoader();
    let data: { reason: string; status?: number };
    console.log(error);

    // Handle translation file loading errors gracefully
    if (error.url && error.url.includes('assets/i18n/')) {
      console.warn('Translation file not found:', error.url);
      // Return empty observable to prevent pipe error
      return of(null);
    }

    switch (error.status) {
      case 0:
        data = {
          reason: this.language.Lang === 'ar'
            ? 'عذرا، هناك خطأ ما.'
            : 'Sorry, Something Went Wrong in server.',
        };
        break;

      case 400:
        console.log(error);

        for (const pageName in error.error) {
          if (error.error.hasOwnProperty(pageName)) {
            let data = '';
            const element = error.error[pageName];
            data += `${pageName} \n`;
            for (const field in element) {
              if (element.hasOwnProperty(field)) {
                const fieldMessage = element[field];
                let msg = `${field}: ${fieldMessage}`.replace(/\$./g, '').trim();
                msg = msg.split('Path')[0];
                data += msg;
              }
            }
            this.alertService.errorHandler({
              reason: data,
              status: error.error
            });
          }
        }
        break;

      case 401:
        this.alertService.errorMessage(
          this.language.Lang === 'en'
            ? 'Username or password is incorrect'
            : 'اسم المستخدم او كلمه المرور غير صحيحه'
        );
        // TODO
        this.authService.logout();
        break;

      case 403:
        data = {
          reason: 'Sorry, you aren\'t Authorized',
        };
        break;

      case 404:
        data = {
          reason: this.language.Lang === 'en' ?
            'Not Found' :
            'المحتوى غير موجود'
        };
        break;

      case 500:

        data = {
          reason:
            this.language.Lang === 'en' ?
              'internal serve error' :
              'خطأ في السيرفر'

        };
        break;

      default:
        data = {
          reason:
            this.language.Lang === 'ar'
              ? 'عذرا، هناك خطأ ما.'
              : 'Sorry, Something Went Wrong.',
        };
        break;
    }

    if (data) {
      this.alertService.errorHandler(data);
    }
    return throwError(() => error);
  }

  /* perttyJson(json){
     if(typeof json != 'string'){
       json = JSON.stringify(json, undefined,2);
     }
     json.replace()
   }*/
}
